import React from 'react';
import ServicesAccordion from './common/ServicesAccordion';
import { translate } from 'components/Translation';
import SimpleAccordionContentWrapper from './common/SimpleAccordionContentWrapper';
import { SingleSubscriberProduct } from 'utils/api/models/subscriberProducts/singleSubscriberProduct';

interface IMobilePrepaidProps {
	subscriberProducts: SingleSubscriberProduct[];
	showOnlyActive: boolean;
}

const MobilePrepaid = ({ showOnlyActive, subscriberProducts }: IMobilePrepaidProps) => {
	return (
		<ServicesAccordion
			collapses={[
				{
					title: translate('number.services.mobile.internet.plans'),
					content: (
						<SimpleAccordionContentWrapper
							group="PREPAID"
							type="DATA"
							showOnlyActive={showOnlyActive}
							name={(singlePackage) => singlePackage.name}
							description={() => ''}
							activationDisabled
							subscriberProducts={subscriberProducts}
						/>
					),
				},
			]}
		/>
	);
};

export default MobilePrepaid;
